import { Button } from "@/js/glidespec";
import { useToaster } from "@/js/Providers/ToasterProvider";
import { useUser } from "@/js/Providers/UserProvider";
import React from "react";
import { useTranslation } from "react-i18next";

export default function PostingLog() {
    const {user} = useUser();
    const {t} = useTranslation();
    const toast = useToaster();

    const handleCopy = () => {
        navigator.clipboard.writeText(`${import.meta.env.VITE_APP_URL}/api/csv/${user!.id}?key=${user!.log_key}`);
        toast({
            type: "success",
            title: t("copiedToClipboard.title"),
            text: t("copiedToClipboard.text"),
            duration: 5000
        })
    }

    return (
        <div className="flex flex-col gap-[30px] max-w-[500px] w-full">
            <div className="flex flex-col gap-2">
                <label className="body-m-md">{t("settings.postingLog.endpoint")}</label>
                <div className="flex gap-3">
                    <div className="h-10 px-4 flex flex-1 items-center rounded-xl border-2 border-neutral-200 body-m overflow-ellipsis whitespace-nowrap overflow-hidden">
                        {`${import.meta.env.VITE_APP_URL}/api/csv/${user!.id}?key=${user!.log_key}`}
                    </div>
                    <Button variant="primary" onClick={handleCopy}>{t("copy")}</Button>
                </div>
            </div>
        </div>
    )
}